import { Button, TableBody, TableCell, TableHead } from "@mui/material";
import { DataHistory } from "../../../../gobalType";
import { formatMoneyData } from "../../../../utils/storage";
import { theme } from "../../../../utils/theme";
import TitleText from "../../../../components/Text/TitleText";
import DefaultText from "../../../../components/Text/DefaultText";
import { Table, TableRow } from "../OrderDetail.style";

type OrderItemsTableProps = {
  orderDetail?: DataHistory;
  onBuyAgain: (item: any) => void;
};

export function OrderItemsTable({ orderDetail, onBuyAgain }: OrderItemsTableProps) {
  let totalPrice = 0;

  return (
    <Table aria-label="caption table">
      <TableHead>
        <TableRow
          style={{ backgroundColor: "#e5e5e5", cursor: "default" }}
          className="table-head">
          <TableCell id="cell" align="center">
            PRODUCT
          </TableCell>
          <TableCell id="cell" align="center">
            SIZE
          </TableCell>
          <TableCell id="cell" align="center">
            QTY
          </TableCell>
          <TableCell id="cell" align="center">
            PRICE
          </TableCell>
          <TableCell id="cell" align="center">
            AMOUNT
          </TableCell>
          <TableCell id="cell" align="center" />
        </TableRow>
      </TableHead>

      <TableBody>
        {orderDetail?.order_details?.map((item: any, index: number) => {
          const amount = item.total * item.price;
          totalPrice += Number(amount);

          return (
            <TableRow key={index}>
              <TableCell id="cell" align="center" sx={{ textAlign: "left !important" }}>
                <DefaultText>{item?.product?.name}</DefaultText>
              </TableCell>
              <TableCell id="cell" align="center">
                {item.size.name !== "default" && item.size.name}
              </TableCell>
              <TableCell id="cell" align="right">
                <DefaultText style={{ marginRight: "10px" }}>{item.total}</DefaultText>
              </TableCell>
              <TableCell id="cell" align="right">
                <DefaultText style={{ marginRight: "10px" }}>
                  {formatMoneyData(item.price)}
                </DefaultText>
              </TableCell>
              <TableCell id="cell" align="right">
                <DefaultText style={{ marginRight: "10px" }}>
                  {formatMoneyData(amount)}
                </DefaultText>
              </TableCell>
              <TableCell id="cell" align="center">
                <Button
                  sx={{
                    borderRadius: 5,
                    backgroundColor: "#e4e5e9",
                    color: `${theme.palette.text.body}`,
                    ":hover": { backgroundColor: "#e4e5e9" },
                    fontWeight: 700,
                    padding: { xs: "5px 5px", sm: "6px 16px" },
                  }}
                  onClick={() => onBuyAgain(item)}
                  variant="contained">
                  <DefaultText>BUY AGAIN</DefaultText>
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>

      <TableHead>
        <TableRow style={{ cursor: "default !important " }}>
          <TableCell
            id="cell"
            colSpan={3}
            align="center"
            sx={{ borderBottom: "0 !important", backgroundColor: "#fff !important" }}
          />
          <TableCell id="cell" align="center" sx={{ borderBottom: "0 !important" }}>
            <TitleText>TOTAL</TitleText>
          </TableCell>
          <TableCell id="cell" align="right" sx={{ borderBottom: "0 !important" }}>
            <TitleText style={{ marginRight: "10px" }}>
              {formatMoneyData(totalPrice)}
            </TitleText>
          </TableCell>
          <TableCell
            id="cell"
            align="center"
            sx={{ borderBottom: "0 !important", backgroundColor: "#fff !important" }}
          />
        </TableRow>
      </TableHead>
    </Table>
  );
}
